module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nfor (var i = 0; i < data.length; i++) {\n    var _uuid = Math.floor((Math.random() * 1000000) + 1);\n    var obj = data[i];\n    var title = '';\n    if(obj.title){\n        title = obj.title;\n    }else if(obj.alt){\n        title = obj.alt;\n    }\n\n    var phatomTitle = title;\n\n    if(obj.dataTracking){\n        var splittedTracking = obj.dataTracking.split('|');\n        phatomTitle = splittedTracking[0];\n    }\n\n    var id;\n    if(obj.id){\n        id = obj.id\n    }else{\n        id = obj.contentId\n    }\n\n    var contentType = 'show';\n\n    if(obj.contentType){\n        contentType = obj.contentType;\n    }\n\n    if(obj.isMovie){\n        contentType = 'movie';\n    }\n\n    var impressionContentType = contentType;\n    if(obj.isOnNow){\n        impressionContentType = obj.streamType;\n    }\n\n    if ((obj.locked || obj.bundleLocked) && data[i].isUserSubscriber) {\n        if(obj.orientation == 'portrait'){\n            obj.lockIconClass = 'bundle-lock portrait';\n        }else{\n            obj.lockIconClass = 'bundle-lock';\n        }\n\n        obj.lockGradientClass = 'bundle-lock-gradient';\n    }\n\n    var cmsId = '';\n    if(obj.cmsId) {\n        cmsId = obj.cmsId;\n    }\n\n    var linkClasses = '';\n    if(data[i].status === 'PREMIUM' && !data[i].isUserSubscriber) {\n        linkClasses += ' subscribe';\n    }\n\n%>\n\n\n    <% if(data[i]) { %>\n\n    <!-- ABTest: homepage descriptions :: contentId used by growth team -->\n    <a class=\"link <%= (data[i].status === 'PREMIUM' && !data[i].isUserSubscriber)?'subscribe':'' %> <%= linkClasses %>\"\n        data-cta=\"<%=data[i].button.label%>\"\n       aria-label=\"<% if(title) { %><%= title %><% } %>\"\n        <% if(data[i].titleSlug) { %>\n        aria-describedby=\"<%= data[i].titleSlug %>-content\"\n        <% } %>\n        <% if(id) { %>\n            id=\"<%= id %>\"\n        <% } %>\n\n        <% if(data[i].genre) { %>\n            data-genre=\"<%= data[i].genre %>\"\n        <% } %>\n\n        <% if(data[i].showGenre) { %>\n            data-genre=\"<%= data[i].showGenre %>\"\n        <% } %>\n\n        <% if(data[i].href !== '') { %>\n            href=\"<%= data[i].href %>\"\n        <% } %>\n\n        <% if(data[i].actionTarget !== '') { %>\n            target=\"<%= data[i].actionTarget %>\"\n        <% } %>\n\n        <% if(title !== '') { %>\n            title=\"<%= title %>\"\n        <% } %>\n\n        <% if(data[i].aaLink !== '') { %>\n            aa-link=\"<%= data[i].aaLink %>\"\n        <% } %>\n\n        <% if(data[i].dataTracking) { %>\n            data-tracking=\"<%= data[i].dataTracking %>\"\n        <% } %>\n\n        <% if(data[i].content_id) { %>\n            vilynx-id=\"<%=data[i].content_id%>\"\n        <% } %>\n\n        <% if (typeof data[i].contentId !== 'undefined') { %>\n                <% if(data[i].contentId) { %>\n                    vilynx-id=\"<%=data[i].contentId%>\"\n                <% } %>\n        <% } %>\n\n        <% if (data[i].promoTile) { %>\n            data-fathom = '<%=data[i].hubId%>||0|promo_<%=data[i].contentType%>||<%=data[i].title%>||'\n            data-impression = '<%=data[i].hubId%>||0|promo_<%=data[i].contentType%>||<%=data[i].title%>|||||'\n        <% } else { %>\n            data-fathom = '<%=data[i].contentIdFathom%>|getdisplayIDAbove|<%=data[i].position%>|<%=contentType%>|<%=data[i].recoId%>|<%=phatomTitle%>|<%=data[i].rankModel%>|<%=data[i].pvrModel%>'\n            data-impression = '<%=data[i].contentIdFathom%>|getdisplayIDAbove|<%=data[i].position%>|<%=impressionContentType%>|<%=data[i].recoId%>|<%=phatomTitle%>|<%=data[i].rankModel%>|<%=data[i].pvrModel%>|<%=data[i].badgeLabel%>|<%=data[i].bundleLocked%>|<%=cmsId%>|prominent|'\n        <% } %>\n    >\n        <% if(data[i].titleSlug) { %>\n        <span class=\"aria-item-content\" id=\"<%= data[i].titleSlug %>-content\">\n                    <%= data[i].about %>\n                </span>\n        <% } %>\n        <div class=\"prominent-thumb-wrapper <% if(data[i].onNowTitle) { %>always-on<% } %>\">\n\n            <img class=\"thumb lazy\"\n                <% if(data[i].condensedBackgroundImage) { %>\n                    data-src=\"<%= data[i].condensedBackgroundImage %>\"\n                <% } %>\n                <% if(data[i].alt) { %>\n                    alt=\"<%= data[i].alt %>\"\n                <% } %>\n            >\n\n              <div class=\"prominent-overlay-components\">\n                <div class=\"prominent-logo  <% if (CBS.Registry.region.international) { %> prominent-intl-spacing <% } %>\">\n                    <% if(data[i].titleLogo) { %>\n                        <img class=\"prominent-logo\" src=\"<%= data[i].titleLogo %>\" />\n                    <% } else { %>\n                        <p class=\"prominent-logo-fallback\"><%= data[i].titleText %></p>\n                    <% } %>\n                </div>\n                <div class=\"prominent-metadata\">\n                    <% if (!CBS.Registry.region.international) { %>\n                        <% if ( ((data[i].locked || data[i].bundleLocked) && data[i].isUserSubscriber) || (data[i].isLocal && data[i].lockIcon && !data[i].isUserSubscriber) ) { %>\n                            <div class=\"<%= data[i].lockGradientClass %>\"></div>\n                            <div class=\"label <%= data[i].lockIconClass %>\">\n                                <img src=\"<%= data[i].lockIcon %>\"/>\n                            </div>\n                        <% } %>\n                    <% } %>\n                    <p><%= data[i].genre.toUpperCase() %></p>\n                 </div>  \n            </div>\n\n        </div>\n\n      \n    </a>\n\n    <div class=\"break\"></div>\n\n    <% } %>\n\n<%  } %>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/prominentCarousel/prominentCarousel.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
for (var i = 0; i < data.length; i++) {
    var _uuid = Math.floor((Math.random() * 1000000) + 1);
    var obj = data[i];
    var title = '';
    if(obj.title){
        title = obj.title;
    }else if(obj.alt){
        title = obj.alt;
    }

    var phatomTitle = title;

    if(obj.dataTracking){
        var splittedTracking = obj.dataTracking.split('|');
        phatomTitle = splittedTracking[0];
    }

    var id;
    if(obj.id){
        id = obj.id
    }else{
        id = obj.contentId
    }

    var contentType = 'show';

    if(obj.contentType){
        contentType = obj.contentType;
    }

    if(obj.isMovie){
        contentType = 'movie';
    }

    var impressionContentType = contentType;
    if(obj.isOnNow){
        impressionContentType = obj.streamType;
    }

    if ((obj.locked || obj.bundleLocked) && data[i].isUserSubscriber) {
        if(obj.orientation == 'portrait'){
            obj.lockIconClass = 'bundle-lock portrait';
        }else{
            obj.lockIconClass = 'bundle-lock';
        }

        obj.lockGradientClass = 'bundle-lock-gradient';
    }

    var cmsId = '';
    if(obj.cmsId) {
        cmsId = obj.cmsId;
    }

    var linkClasses = '';
    if(data[i].status === 'PREMIUM' && !data[i].isUserSubscriber) {
        linkClasses += ' subscribe';
    }


    ; __line = 61
    ; __append("\n\n\n    ")
    ; __line = 64
    ;  if(data[i]) { 
    ; __append("\n\n    <!-- ABTest: homepage descriptions :: contentId used by growth team -->\n    <a class=\"link ")
    ; __line = 67
    ; __append(escapeFn( (data[i].status === 'PREMIUM' && !data[i].isUserSubscriber)?'subscribe':'' ))
    ; __append(" ")
    ; __append(escapeFn( linkClasses ))
    ; __append("\"\n        data-cta=\"")
    ; __line = 68
    ; __append(escapeFn(data[i].button.label))
    ; __append("\"\n       aria-label=\"")
    ; __line = 69
    ;  if(title) { 
    ; __append(escapeFn( title ))
    ;  } 
    ; __append("\"\n        ")
    ; __line = 70
    ;  if(data[i].titleSlug) { 
    ; __append("\n        aria-describedby=\"")
    ; __line = 71
    ; __append(escapeFn( data[i].titleSlug ))
    ; __append("-content\"\n        ")
    ; __line = 72
    ;  } 
    ; __append("\n        ")
    ; __line = 73
    ;  if(id) { 
    ; __append("\n            id=\"")
    ; __line = 74
    ; __append(escapeFn( id ))
    ; __append("\"\n        ")
    ; __line = 75
    ;  } 
    ; __append("\n\n        ")
    ; __line = 77
    ;  if(data[i].genre) { 
    ; __append("\n            data-genre=\"")
    ; __line = 78
    ; __append(escapeFn( data[i].genre ))
    ; __append("\"\n        ")
    ; __line = 79
    ;  } 
    ; __append("\n\n        ")
    ; __line = 81
    ;  if(data[i].showGenre) { 
    ; __append("\n            data-genre=\"")
    ; __line = 82
    ; __append(escapeFn( data[i].showGenre ))
    ; __append("\"\n        ")
    ; __line = 83
    ;  } 
    ; __append("\n\n        ")
    ; __line = 85
    ;  if(data[i].href !== '') { 
    ; __append("\n            href=\"")
    ; __line = 86
    ; __append(escapeFn( data[i].href ))
    ; __append("\"\n        ")
    ; __line = 87
    ;  } 
    ; __append("\n\n        ")
    ; __line = 89
    ;  if(data[i].actionTarget !== '') { 
    ; __append("\n            target=\"")
    ; __line = 90
    ; __append(escapeFn( data[i].actionTarget ))
    ; __append("\"\n        ")
    ; __line = 91
    ;  } 
    ; __append("\n\n        ")
    ; __line = 93
    ;  if(title !== '') { 
    ; __append("\n            title=\"")
    ; __line = 94
    ; __append(escapeFn( title ))
    ; __append("\"\n        ")
    ; __line = 95
    ;  } 
    ; __append("\n\n        ")
    ; __line = 97
    ;  if(data[i].aaLink !== '') { 
    ; __append("\n            aa-link=\"")
    ; __line = 98
    ; __append(escapeFn( data[i].aaLink ))
    ; __append("\"\n        ")
    ; __line = 99
    ;  } 
    ; __append("\n\n        ")
    ; __line = 101
    ;  if(data[i].dataTracking) { 
    ; __append("\n            data-tracking=\"")
    ; __line = 102
    ; __append(escapeFn( data[i].dataTracking ))
    ; __append("\"\n        ")
    ; __line = 103
    ;  } 
    ; __append("\n\n        ")
    ; __line = 105
    ;  if(data[i].content_id) { 
    ; __append("\n            vilynx-id=\"")
    ; __line = 106
    ; __append(escapeFn(data[i].content_id))
    ; __append("\"\n        ")
    ; __line = 107
    ;  } 
    ; __append("\n\n        ")
    ; __line = 109
    ;  if (typeof data[i].contentId !== 'undefined') { 
    ; __append("\n                ")
    ; __line = 110
    ;  if(data[i].contentId) { 
    ; __append("\n                    vilynx-id=\"")
    ; __line = 111
    ; __append(escapeFn(data[i].contentId))
    ; __append("\"\n                ")
    ; __line = 112
    ;  } 
    ; __append("\n        ")
    ; __line = 113
    ;  } 
    ; __append("\n\n        ")
    ; __line = 115
    ;  if (data[i].promoTile) { 
    ; __append("\n            data-fathom = '")
    ; __line = 116
    ; __append(escapeFn(data[i].hubId))
    ; __append("||0|promo_")
    ; __append(escapeFn(data[i].contentType))
    ; __append("||")
    ; __append(escapeFn(data[i].title))
    ; __append("||'\n            data-impression = '")
    ; __line = 117
    ; __append(escapeFn(data[i].hubId))
    ; __append("||0|promo_")
    ; __append(escapeFn(data[i].contentType))
    ; __append("||")
    ; __append(escapeFn(data[i].title))
    ; __append("|||||'\n        ")
    ; __line = 118
    ;  } else { 
    ; __append("\n            data-fathom = '")
    ; __line = 119
    ; __append(escapeFn(data[i].contentIdFathom))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(data[i].position))
    ; __append("|")
    ; __append(escapeFn(contentType))
    ; __append("|")
    ; __append(escapeFn(data[i].recoId))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(data[i].rankModel))
    ; __append("|")
    ; __append(escapeFn(data[i].pvrModel))
    ; __append("'\n            data-impression = '")
    ; __line = 120
    ; __append(escapeFn(data[i].contentIdFathom))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(data[i].position))
    ; __append("|")
    ; __append(escapeFn(impressionContentType))
    ; __append("|")
    ; __append(escapeFn(data[i].recoId))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(data[i].rankModel))
    ; __append("|")
    ; __append(escapeFn(data[i].pvrModel))
    ; __append("|")
    ; __append(escapeFn(data[i].badgeLabel))
    ; __append("|")
    ; __append(escapeFn(data[i].bundleLocked))
    ; __append("|")
    ; __append(escapeFn(cmsId))
    ; __append("|prominent|'\n        ")
    ; __line = 121
    ;  } 
    ; __append("\n    >\n        ")
    ; __line = 123
    ;  if(data[i].titleSlug) { 
    ; __append("\n        <span class=\"aria-item-content\" id=\"")
    ; __line = 124
    ; __append(escapeFn( data[i].titleSlug ))
    ; __append("-content\">\n                    ")
    ; __line = 125
    ; __append(escapeFn( data[i].about ))
    ; __append("\n                </span>\n        ")
    ; __line = 127
    ;  } 
    ; __append("\n        <div class=\"prominent-thumb-wrapper ")
    ; __line = 128
    ;  if(data[i].onNowTitle) { 
    ; __append("always-on")
    ;  } 
    ; __append("\">\n\n            <img class=\"thumb lazy\"\n                ")
    ; __line = 131
    ;  if(data[i].condensedBackgroundImage) { 
    ; __append("\n                    data-src=\"")
    ; __line = 132
    ; __append(escapeFn( data[i].condensedBackgroundImage ))
    ; __append("\"\n                ")
    ; __line = 133
    ;  } 
    ; __append("\n                ")
    ; __line = 134
    ;  if(data[i].alt) { 
    ; __append("\n                    alt=\"")
    ; __line = 135
    ; __append(escapeFn( data[i].alt ))
    ; __append("\"\n                ")
    ; __line = 136
    ;  } 
    ; __append("\n            >\n\n              <div class=\"prominent-overlay-components\">\n                <div class=\"prominent-logo  ")
    ; __line = 140
    ;  if (CBS.Registry.region.international) { 
    ; __append(" prominent-intl-spacing ")
    ;  } 
    ; __append("\">\n                    ")
    ; __line = 141
    ;  if(data[i].titleLogo) { 
    ; __append("\n                        <img class=\"prominent-logo\" src=\"")
    ; __line = 142
    ; __append(escapeFn( data[i].titleLogo ))
    ; __append("\" />\n                    ")
    ; __line = 143
    ;  } else { 
    ; __append("\n                        <p class=\"prominent-logo-fallback\">")
    ; __line = 144
    ; __append(escapeFn( data[i].titleText ))
    ; __append("</p>\n                    ")
    ; __line = 145
    ;  } 
    ; __append("\n                </div>\n                <div class=\"prominent-metadata\">\n                    ")
    ; __line = 148
    ;  if (!CBS.Registry.region.international) { 
    ; __append("\n                        ")
    ; __line = 149
    ;  if ( ((data[i].locked || data[i].bundleLocked) && data[i].isUserSubscriber) || (data[i].isLocal && data[i].lockIcon && !data[i].isUserSubscriber) ) { 
    ; __append("\n                            <div class=\"")
    ; __line = 150
    ; __append(escapeFn( data[i].lockGradientClass ))
    ; __append("\"></div>\n                            <div class=\"label ")
    ; __line = 151
    ; __append(escapeFn( data[i].lockIconClass ))
    ; __append("\">\n                                <img src=\"")
    ; __line = 152
    ; __append(escapeFn( data[i].lockIcon ))
    ; __append("\"/>\n                            </div>\n                        ")
    ; __line = 154
    ;  } 
    ; __append("\n                    ")
    ; __line = 155
    ;  } 
    ; __append("\n                    <p>")
    ; __line = 156
    ; __append(escapeFn( data[i].genre.toUpperCase() ))
    ; __append("</p>\n                 </div>  \n            </div>\n\n        </div>\n\n      \n    </a>\n\n    <div class=\"break\"></div>\n\n    ")
    ; __line = 167
    ;  } 
    ; __append("\n\n")
    ; __line = 169
    ;   } 
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/prominentCarousel/prominentCarousel.tpl"

}